import React, {FC} from 'react'
import classnames from 'classnames'
import {Link} from 'react-router-dom'

interface LinkProps {
  pathname: string
  linkName: string
  current: boolean
  first?: boolean
  last?: boolean
  count?: number
  classNames?: string
  children?: React.ReactNode
  onClick?: () => void
}

export const NavLink: FC<LinkProps> = ({
  pathname,
  current,
  linkName,
  children,
  classNames = '',
  onClick,
}) => {
  return (
    <Link
      to={pathname}
      data-cy={linkName}
      onClick={onClick}
      aria-label={`Navigate to ${linkName}`}
    >
      <div
        className={classnames(
          `group flex items-center text-sm karla-bold leading-snug ${classNames} h-14 border-b-3 mx-4 hover:border-white`,
          {
            'text-white border-white': current,
            'text-gray-1000 border-transparent': !current,
          },
        )}
      >
        {children}
        <span>{linkName}</span>
      </div>
    </Link>
  )
}
